import parser from 'ua-parser-js';

const parsedUA = typeof window !== "undefined" ? parser(window?.navigator?.userAgent) : undefined;

export default (userSummary = {}, pageGroup = '', nativeapp = 'false') => ({
    market: document?.body?.getAttribute('data-country') || null,
    region: document?.body?.getAttribute('data-catalog') || null,
    language: document?.body?.getAttribute('data-language') || null,
    logged_in: userSummary.userAuthenticationStatus === "Full",
    is_eip: userSummary.isEip === true,
    new_returning: userSummary.hasOrder === 'true' ? 'returning user' : 'new user',
    view_name: pageGroup || null,
    browser: parsedUA?.browser?.name || null,
    device_type: parsedUA?.device?.type || 'desktop',
    platform_info: `${parsedUA?.os?.name || ''}${parsedUA?.os?.version || ''}` || null,
    native_app: nativeapp || 'false',
    user_agent: parsedUA?.ua || null
})

